export default __webpack_public_path__ + "static/media/guest_16_02.f9815c54.png";